// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import PartRequestForm from '../../../state/part-request-form';
import {noPartsReturned} from '../../../services/return-status';

function handleCourierNameChange(event) {

    this.onCourierNameChange(event.target.value);

}

function handleTrackingNumberChange(event) {

    this.onTrackingNumberChange(event.target.value);

}

const ShippingDetails = props =>
    <div className='shipping-details'>
        {props.partRequestForm.returnStatus.id === noPartsReturned ?
            null :
            <div className='courier-details'>
                <LabeledFormInput
                    className='courier-name'
                    label='ACTUAL_COURIER_NAME'
                >
                    <EditableField
                        isEditable={props.isEditableAndAccessible}
                        value={props.partRequestForm.courierInfo.courierName}
                    >
                        <input
                            maxLength={35}
                            onChange={props::handleCourierNameChange}
                            type='text'
                            value={props.partRequestForm.courierInfo.courierName}
                        />
                    </EditableField>
                </LabeledFormInput>
                <LabeledFormInput
                    className='tracking-number'
                    label='TRACKING_NUMBER'
                >
                    <EditableField
                        isEditable={props.isEditableAndAccessible}
                        value={props.partRequestForm.courierInfo.returnTrackingNumber}
                    >
                        <input
                            maxLength={30}
                            onChange={props::handleTrackingNumberChange}
                            type='text'
                            value={props.partRequestForm.courierInfo.returnTrackingNumber}
                        />
                    </EditableField>
                </LabeledFormInput>
            </div>
        }
    </div>;

ShippingDetails.displayName = 'ShippingDetails';
ShippingDetails.propTypes = {
    isEditableAndAccessible: PropTypes.bool.isRequired,
    onCourierNameChange: PropTypes.func.isRequired,
    onTrackingNumberChange: PropTypes.func.isRequired,
    partRequestForm: PropTypes.instanceOf(PartRequestForm).isRequired
};

export default ShippingDetails;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/part-request-form/shipping-details.js